export default "__VITE_ASSET__e362df90__"